import styled from 'styled-components';

const AddressDisplay = styled.div`
  font-size: 13px;
`;

type Facility = {
  name?: string;
  attention?: string;
  address: {
    address1: string;
    address2?: string;
    city: string;
    state?: {
      abbr: string;
    };
    postalCode?: string;
  };
};

type FacilityDisplayProps = {
  facility: Facility;
};

const FacilityDisplay = ({ facility }: FacilityDisplayProps) => {
  return (
    <AddressDisplay>
      {facility.name && facility.name.trim().length > 0 && (
        <>
          <b>{facility.name}</b>
          <br />
        </>
      )}
      {facility.attention && facility.attention.trim().length > 0 && (
        <>
          <b>{facility.attention}</b>
          <br />
        </>
      )}
      {facility.address.address1}
      <br />
      {facility.address.address2 && (
        <>
          {facility.address.address2}
          <br />
        </>
      )}
      <p>
        {facility.address.city}
        {facility.address.state && (
          <>
            ,&nbsp;
            {facility.address.state.abbr}
          </>
        )}
        {facility.address.postalCode && (
          <>&nbsp;{facility.address.postalCode}</>
        )}
      </p>
    </AddressDisplay>
  );
};

export default FacilityDisplay;
